export default __webpack_public_path__ + "static/blog-404-dashboard-desktop-6f7ceccd7b18b3afda6d72b89626e251.png";